function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessSignalIcon = function SvgProcessSignalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-2 -2 41 38",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h34v32H0z",
    style: {
      fill: "transparent",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.304 124.97 60.33 60.331a340.27 340.27 0 0 0-99.967 241.366c0 94.293 38.186 179.626 99.968 241.365l-60.288 60.288A425.34 425.34 0 0 1 85.333 426.667 425.34 425.34 0 0 1 210.304 124.97m603.392 0a425.34 425.34 0 0 1 124.97 301.697 425.34 425.34 0 0 1-124.97 301.696l-60.33-60.331a340.27 340.27 0 0 0 99.967-241.365c0-94.294-38.186-179.627-99.968-241.366l60.288-60.288zm-482.73 120.662 60.373 60.373a170.1 170.1 0 0 0-50.006 120.662c0 47.146 19.115 89.813 50.006 120.661l-60.374 60.373A255.2 255.2 0 0 1 256 426.667c0-70.699 28.672-134.699 74.965-181.035m362.069 0A255.2 255.2 0 0 1 768 426.667 255.2 255.2 0 0 1 693.035 607.7l-60.374-60.373a170.1 170.1 0 0 0 50.006-120.661 170.1 170.1 0 0 0-50.006-120.662zM512 512a85.333 85.333 0 1 1 0-170.667A85.333 85.333 0 0 1 512 512m0 85.333c24.747 0 45.952 17.622 50.517 41.942l56.15 299.392H405.333l56.15-299.392c4.565-24.32 25.77-41.942 50.517-41.942",
    style: {
      fill: "#707070"
    },
    transform: "matrix(.02344 0 0 .0209 5.5 5.387)"
  }));
};
var Memo = /*#__PURE__*/memo(SvgProcessSignalIcon);
export default Memo;